import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import CardMedia from '@mui/material/CardMedia';
import TnC from './tnc.jpg';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalTheme } from '../../theme';

const PrivacyPolicyPage = () => {
    return (
        <ThemeProvider theme={GlobalTheme}>
            <CssBaseline />
            <Container maxWidth={false} disableGutters>
                <Box sx={{
                    '&.muiCard-root': { borderRadius: 0 },
                }}>
                    <CardMedia
                        sx={{ height: 500 }}
                        image={TnC}
                        title=""
                    />
                </Box>
            </Container>
            <Container maxWidth="lg" sx={{ mb: 2 }}>
                <Box sx={{ padding: 2, mt: 3 }}>
                    <Typography variant="h4" gutterBottom>
                        Refund Policy
                    </Typography>
                    <Typography id="terms-description" variant="subtitle2" fontWeight={200} component="div">

                        <p><strong>Processing Refunds</strong></p>
                        <p>
                            Refund requests will be processed within 7-14 business days from the date of approval. Refunds will be credited to the original mode of payment unless otherwise agreed upon.
                        </p>
                        <p>
                            <strong>Partial Refunds</strong>
                        </p>

                        <p> If you cancel a portion of a multi-service booking (e.g., hotel + flight), the refund will be calculated based on the specific cancellation policies of each service provider.</p>

                        <p><strong>Non-Refundable Charges</strong></p>

                        <p>Certain charges, such as service fees, taxes, or third-party vendor costs, may not be refundable.</p>

                        <p><strong>Force Majeure</strong></p>

                        <p>Refunds for cancellations due to events beyond our control (natural disasters, government restrictions, etc.) will be subject to the policies of the service providers involved.</p>
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
};

export default PrivacyPolicyPage;
